import gql from 'graphql-tag'
import { CART_MUTATION_RESULT } from './fragments.graphql'

export const UPDATE_CART_WITH_MULTIPLE_PRODUCTS = gql`
  ${CART_MUTATION_RESULT}

  mutation UpdateCartWithMultipleProducts(
    $cartItemParams: [CartItemParamInput]!
    $withRequiredEndUserInformation: Boolean = false
  ) {
    updateCartWithProducts(cartItemParams: $cartItemParams) {
      ...CartItemResult
    }
  }
`
